
<div class="column-flex">
    <div class="form-label">
        <ng-container>
            {{ 'system-settings.eap.led.pattern-selection-dialog.title' | translate }}
        </ng-container>
    </div>

    <div class="main-container">
        <form class="input-form">
            <div class="graph-name-label">
                {{ 'system-settings.eap.led.pattern-selection-dialog.dropdown.name' | translate }}
            </div>
            <app-simple-dropdown
                style="height: 56px"
                [options]="patternOptions"
                [selectedOption]="selectedPatternId"
                (onOptionSelected)="handleTypeChanged($event)">
            </app-simple-dropdown>
        </form>
    </div>

    <div class="buttons-container">
        <div
            class="unassign button"
            (click)="unassign()"
            [ngClass]="{ button_disabled: !this.data.eap.eapLedPatternId }">
            {{ 'system-settings.eap.led.pattern-selection-dialog.clear' | translate }}
        </div>
        <div class="right-buttons">
            <div class="cancel button"(click)="cancel()">
                {{ 'dlg.cancel' | translate }}
            </div>
            <div
                class="create button"
                (click)="save()"
                [ngClass]="{ button_disabled: isSaveDisabled }">
                {{ 'dlg.save' | translate }}
            </div>
        </div>
    </div>
</div>


<app-confirmation-window
    #cancelConfirmation
    [mainLabel]="'system-settings.eap.cancel.dialog.title'"
    [discardLabel]="'system-settings.eap.cancel.dialog.discard'"
    [goBackLabel]="'system-settings.eap.cancel.dialog.go-back'"
    [saveLabel]="'system-settings.eap.cancel.dialog.save'">
</app-confirmation-window>
